import React, { useState } from 'react';
import $i18n, { langList, setLang } from '@alife/panda-i18n';
import locale from './locales'; // 上述文件夹
import LogOff from './components/log-off';
import { icons } from './utils';
import './index.scss';
$i18n.addLocale(locale);
function removeURLParameter(url, parameter) {
    var urlParts = url.split('?');
    if (urlParts.length >= 2) {
        var prefix = encodeURIComponent(parameter) + '=';
        var parts = urlParts[1].split(/[&;]/g);
        // 遍历参数，删除指定参数
        for (var i = 0; i < parts.length; i++) {
            if (parts[i].lastIndexOf(prefix, 0) !== -1) {
                parts.splice(i, 1);
                i--;
            }
        }
        // 重构URL
        url = urlParts[0] + (parts.length > 0 ? '?' + parts.join('&') : '');
        return url;
    }
    else {
        return url;
    }
}
const CnCpoTalentNavM = ({ navList, navigateTo, isCampus = false, languageList = [], hasLogin = false, handleLoginOut = () => { }, handleLoginOff = () => { }, handleChangeLang = () => { }, isReverse = false, className }) => {
    const pathName = location.pathname === '/' ? '/index' : location.pathname;
    const [menuOpen, setMenuOpen] = useState(false);
    const [menuType, setMenuType] = useState('nav'); // nav：导航 lang：语言 login: 登录
    const gotoPath = (url) => {
        // 跳转外链
        if (/^https?:\/\//.test(url)) {
            return window.open(url);
        }
        const path = location.pathname;
        if (path.indexOf(url) === -1) {
            setMenuOpen(false);
            navigateTo(url);
        }
    };
    const getBackHomePage = () => {
        if (isCampus)
            return navigateTo('/campus/index');
        return '/index';
    };
    const renderMenuList = () => {
        if (menuType === 'nav') {
            return (React.createElement("ul", null, navList.map((item) => {
                return (React.createElement("li", { onClick: () => gotoPath(item.path) },
                    React.createElement("span", null, item.title),
                    pathName.includes(item.key) && (React.createElement("span", { dangerouslySetInnerHTML: {
                            __html: icons.checkedIcon
                        } }))));
            })));
        }
        if (menuType === 'lang') {
            return (React.createElement("ul", null, languageList.map((code) => {
                return (React.createElement("li", { onClick: () => {
                        setLang(code);
                        handleChangeLang && handleChangeLang(code);
                        const newUrl = removeURLParameter(location.href, 'lang');
                        location.href = newUrl;
                    } },
                    React.createElement("span", null, langList?.find((item) => item.value === code)?.label),
                    $i18n.getLang() === code && (React.createElement("span", { dangerouslySetInnerHTML: {
                            __html: icons.checkedIcon
                        } }))));
            })));
        }
        if (menuType === 'login') {
            return (React.createElement("ul", null,
                React.createElement("li", { onClick: handleLoginOut }, $i18n.get({
                    id: 'Logout',
                    dm: '退出登录'
                })),
                React.createElement(LogOff, { handleLoginOff: handleLoginOff },
                    React.createElement("li", { style: {
                            color: '#F35832'
                        } }, $i18n.get({
                        id: 'Logoff',
                        dm: '注销账号'
                    })))));
        }
    };
    return (React.createElement("div", { className: `m-talent-nav-content ${className}` },
        React.createElement("div", { className: `m-talent-nav-fix-content ${isReverse ? 'm-talent-nav-fix-content-reverse' : ''} ${menuOpen ? 'm-talent-nav-fix-content-open' : ''} ` },
            React.createElement("div", { 
                // eslint-disable-next-line react/no-danger
                onClick: getBackHomePage, dangerouslySetInnerHTML: !isCampus
                    ? {
                        __html: menuOpen
                            ? icons.activeLogo
                            : isReverse
                                ? icons.blackLogo
                                : icons.logo
                    }
                    : {
                        __html: menuOpen
                            ? icons.activeCampusLogo
                            : isReverse
                                ? icons.blackCampusLogo
                                : icons.campusLogo
                    } }),
            React.createElement("div", { className: "m-talent-nav-fix-right-icon" },
                React.createElement("div", { className: `${menuOpen ? 'crumbs-icon' : ''}`, onClick: () => {
                        setMenuOpen(true);
                        setMenuType('nav');
                    }, 
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML: {
                        __html: isReverse ? icons.blackCrubIcon : icons.crumbsIcon
                    } }),
                React.createElement("div", { className: `ml16 ${menuOpen ? 'crumbs-icon' : ''}`, onClick: () => {
                        setMenuOpen(true);
                        setMenuType('lang');
                    }, 
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML: {
                        __html: isReverse ? icons.blackLangIcon : icons.langIcon
                    } }),
                !hasLogin ? (React.createElement("div", { className: `ml16 ${menuOpen ? 'crumbs-icon' : ''}`, dangerouslySetInnerHTML: {
                        __html: isReverse
                            ? icons.blackPersonCenterIcon
                            : icons.personCenterIcon
                    }, onClick: () => {
                        // @ts-ignore
                        location.href = `https://${location.host}/personal/${isCampus ? 'campus' : 'social'}-application`;
                    } })) : (React.createElement("div", { className: `ml16 ${menuOpen ? 'crumbs-icon' : ''}`, dangerouslySetInnerHTML: {
                        __html: isReverse ? icons.blackLoginIcon : icons.loginIcon
                    }, onClick: () => {
                        setMenuOpen(true);
                        setMenuType('login');
                    } })),
                menuOpen ? (React.createElement("div", { onClick: () => setMenuOpen(false), 
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML: {
                        __html: icons.closeIcon
                    } })) : null)),
        React.createElement("div", { className: `m-talent-nav-open-content ${menuOpen ? 'm-talent-nav-open' : ''}` }, renderMenuList())));
};
export default CnCpoTalentNavM;
